export const ONE_DAY = 24 * 60 * 60 * 1000;

/**
 * Returns a new timestamp with the timezone offset and timestamp removed (in UTC)
 * @returns number
 * */
export function getUTCDate(now = new Date()) {
  return Math.floor(now.getTime() / ONE_DAY) * ONE_DAY;
}

/**
 * Returns the amount of days between two timestamps
 * @param t1 number
 * @param t2 number
 * @returns number
 *
 */
export function getDateDifference(t1, t2) {
  return Math.floor((t2 - t1) / ONE_DAY);
}